import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      title: 'Giải pháp năng lượng mặt trời hàng đầu Việt Nam',
      subtitle: 'Tiết kiệm lên đến 90% chi phí điện',
      description: 'Gnine Solar tự hào là đơn vị lắp đặt điện mặt trời uy tín, tiên phong với thành tựu 113,5 MWp điện mặt trời hòa lưới.',
      buttonText: 'Tìm hiểu thêm',
      buttonLink: '#about',
      image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80'
    },
    {
      id: 2,
      title: 'Sở hữu điện mặt trời trả góp dễ dàng',
      subtitle: 'Hỗ trợ trả góp lên đến 80% trong 60 tháng',
      description: 'Giải pháp giúp hộ gia đình Việt dễ dàng sở hữu hệ thống điện mặt trời với chi phí hợp lý.',
      buttonText: 'Đăng ký ngay',
      buttonLink: '#contact',
      image: 'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80'
    },
    {
      id: 3,
      title: 'Đối tác chiến lược của Huawei & Growatt',
      subtitle: 'Công nghệ tiên tiến hàng đầu thế giới',
      description: 'Mang đến giải pháp đầu tư điện mặt trời tiên tiến nhất đến gần hơn với người tiêu dùng Việt Nam.',
      buttonText: 'Xem dự án',
      buttonLink: '#projects',
      image: 'https://images.unsplash.com/photo-1559302504-64aae6ca6b6d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section id="home" className="hero">
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="hero-overlay"></div>
            <div className="container">
              <div className="hero-content">
                <span className="hero-subtitle" data-aos="fade-up">
                  {slide.subtitle}
                </span>
                <h1 className="hero-title" data-aos="fade-up" data-aos-delay="100">
                  {slide.title}
                </h1>
                <p className="hero-description" data-aos="fade-up" data-aos-delay="200">
                  {slide.description}
                </p>
                <div className="hero-buttons" data-aos="fade-up" data-aos-delay="300">
                  <a href={slide.buttonLink} className="btn btn-primary">
                    {slide.buttonText}
                    <i className="fas fa-arrow-right ms-2"></i>
                  </a>
                  <a href="#contact" className="btn btn-outline-light">
                    <i className="fas fa-phone-alt me-2"></i>
                    Liên hệ tư vấn
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button className="hero-nav hero-prev" onClick={prevSlide} aria-label="Previous slide">
        <i className="fas fa-chevron-left"></i>
      </button>
      <button className="hero-nav hero-next" onClick={nextSlide} aria-label="Next slide">
        <i className="fas fa-chevron-right"></i>
      </button>

      {/* Dots Navigation */}
      <div className="hero-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`hero-dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          ></button>
        ))}
      </div>

      {/* Stats Bar */}
      <div className="hero-stats">
        <div className="container">
          <div className="stats-wrapper">
            <div className="stat-item">
              <div className="stat-icon">
                <i className="fas fa-solar-panel"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">113.5+</h3>
                <p className="stat-label">MWp Điện mặt trời</p>
              </div>
            </div>
            <div className="stat-item">
              <div className="stat-icon">
                <i className="fas fa-home"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">2689+</h3>
                <p className="stat-label">Hộ gia đình</p>
              </div>
            </div>
            <div className="stat-item">
              <div className="stat-icon">
                <i className="fas fa-building"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">226+</h3>
                <p className="stat-label">Doanh nghiệp</p>
              </div>
            </div>
            <div className="stat-item">
              <div className="stat-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">50+</h3>
                <p className="stat-label">Tỉnh thành</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;